import alt from '../alt';

/**
 * PageAction actions
 */
class PageActionActions {
    /**
	 *
     * @param {PageAction} action
     */
	callAction(action) {
		return action;
	}
}

/**
 *
 * @type {PageActionActions}
 */
let actionActions = alt.createActions(PageActionActions);
export default actionActions;
